import moment from 'moment';
import React, { Component } from 'react';
import { SERVICE_RESPONSE } from '../libs/utils/Const';
import ApiClient from '../libs/apiClient';
import SunatGuideModal from './SunatGuideModal';
import $, { param } from 'jquery';
let apiClient = ApiClient.getInstance();
const status = {
    'C': 'Cerrado',
    'O': 'Abierto'
}
const canceled = {
    'C': 'Cancelado'
}

class ReabsResumeDetailsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sunatGuideData: [],
            showSunatGuideModal: false,
            forceProcess: null,
        }
    }
    renderStep = (label, value, icon, isLast = false, nextStep) => {
        const completed = value !== null && value !== undefined;
        const needNextStep = nextStep?.next ?? false
        const nextStepComplete = (nextStep?.value ?? null) !== null && (nextStep.value ?? null) !== undefined;
        const nextStepAction = (nextStep?.onAction ?? null);
        return (
            <div onClick={nextStepAction} style={{ display: 'flex', alignItems: 'center', flex: '0 0 140px', minWidth: '120px', cursor: 'pointer' }}>
                <div
                    style={{
                        flex: 1,

                        padding: '10px',
                        borderRadius: '10px',
                        backgroundColor: needNextStep && !nextStepComplete ? '#FFF3CD' : completed ? '#e8f5e9' : '#f8f9fa',
                        border: needNextStep && !nextStepComplete ? '1px solid #FFC107' : completed ? '1px solid #28a745' : '1px solid #dee2e6',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                        textAlign: 'center',

                        height: '95px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between'
                    }}
                >
                    <div>
                        <i
                            className={icon}
                            style={{
                                fontSize: '14px',
                                color: needNextStep && !nextStepComplete ? ' #FFC107' : completed ? '#28a745' : '#adb5bd'
                            }}
                        />
                    </div>

                    <div
                        title={label}
                        style={{
                            fontSize: '11px',
                            fontWeight: '600',
                            color: '#6c757d',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical'
                        }}
                    >
                        {label}
                    </div>

                    <div

                        style={{
                            fontSize: '12px',
                            fontWeight: 'bold',
                            color: needNextStep && !nextStepComplete ? ' #FFC107' : completed ? '#28a745' : '#adb5bd',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {value ?? 'Pendiente'}
                    </div>
                </div>

                {!isLast && (
                    <div
                        style={{
                            width: '20px',
                            height: '2px',
                            backgroundColor: '#dee2e6',
                            margin: '0 4px',
                            alignSelf: 'center'
                        }}
                    />
                )}
            </div>
        )
    }
    prepareGuideSUNAT = async (data) => {
        return;
        const { enableSpinner, showAlert } = this.props;
        const dataSearch = {
            entrys: [{
                DocEntry: data.Authorization,
                DocEntryST: data.DocEntry
            }]
        }
        enableSpinner(true)
        const resposeApi = await apiClient.prepareSunatGuide(dataSearch)
        enableSpinner(false)
        if (resposeApi?.status === SERVICE_RESPONSE.SUCCESS) {

            this.setState({
                sunatGuideData: resposeApi?.data ?? [],
                showSunatGuideModal: true,
                forceProcess: true,
            }, () => {
                $('#sunatGuideModal').modal('show');
            })

        } else {
            showAlert({ type: 'warning', message: resposeApi?.message ?? 'Información no disponible' });
        }
    }
    refreshGuideData = (sunatGuideData) => {
        this.setState({
            sunatGuideData
        })
    }
    render() {
        const { showSunatGuideModal
            , sunatGuideData
            , forceProcess
        } = this.state
        const { newOrderModel, enableSpinner, showAlert } = this.props;
        const data = newOrderModel?.lines?.[0];

        return (
            <div
                className="modal fade"
                id="reabsResumeDetailsModal"
                role="dialog"
                style={{ zIndex: 90 }}
            >
                {showSunatGuideModal &&
                    <SunatGuideModal
                        data={sunatGuideData}
                        enableSpinner={enableSpinner}
                        showAlert={showAlert}
                        hideModal={() => this.setState({ showSunatGuideModal: false, sunatGuideData: [] })}
                        forceProcess={forceProcess}
                        continueCreate={() => { }}
                        refreshSunatGuideData={this.refreshGuideData}
                        view={'reabsResume'}
                    />
                }
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40' }}>
                            <h5 className="modal-title">Seguimiento de Solicitud</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span className="text-white">&times;</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            {data && (
                                <div className="container-fluid">

                                    <div
                                        className="row mb-4"
                                        style={{
                                            background: '#f8f9fa',
                                            padding: '15px',
                                            borderRadius: '10px'
                                        }}
                                    >
                                        <div className="col-12 col-md-6">
                                            <b>Planta:</b> {data.Planta}
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <b>Zonal:</b> {data.Zonal}
                                        </div>

                                        <div className="col-12 col-md-6 mt-2">
                                            <b>Solicitud:</b> {data.DocNum}
                                        </div>
                                        <div className="col-12 col-md-6 mt-2">
                                            <b>Fecha:</b> {moment(data.DocDate).format('YYYY-MM-DD')}
                                        </div>
                                        <div className="col-12 col-md-6 mt-2">
                                            <b>Estatus de la Solicitud:</b> {canceled[data?.CANCELED] ?? status[data?.DocStatus] ?? '--'}
                                        </div>

                                    </div>

                                    <div
                                        style={{
                                            display: 'flex',
                                            overflowX: 'auto',
                                            width: '100%',
                                            gap: '4px',
                                            paddingBottom: '8px'
                                        }}
                                    >
                                        {this.renderStep('Solicitud Original', `ST ${data.DocNum}`, 'fas fa-file-alt')}
                                        {this.renderStep('Autorización', data.Authorization, 'fas fa-check')}
                                        {this.renderStep('Cargar Transporte', !(data.DocNumTrasladoTransporte) ? null : `TR ${data.DocNumTrasladoTransporte}`, 'fas fa-truck', false, { next: true, value: (data.DocNumGuideZonal), onAction: () => this.prepareGuideSUNAT(data) })}
                                        {this.renderStep('Guía Zonal', !(data.DocNumGuideZonal) ? null : `ST ${data.DocNumGuideZonal}`, 'fas fa-file-invoice')}
                                        {this.renderStep('Guía cilindros', !(data.DocNum001To014) ? null : `TR ${data.DocNum001To014}`, 'fas fa-dolly')}
                                        {this.renderStep('Carga a Zonal', !(data.DocNum009To014) ? null : `TR ${data.DocNum009To014}`, 'fas fa-warehouse')}
                                        {this.renderStep('Carga cilindros a Transporte', !(data.DocNum014To009) ? null : `TR ${data.DocNum014To009}`, 'fas fa-shipping-fast', true)}
                                    </div>

                                </div>
                            )}
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn botonCerrar text-white"
                                data-dismiss="modal"
                            >
                                Cerrar
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default ReabsResumeDetailsModal;